import React, { useState, useEffect } from 'react';
import { Modal, Table, Button, Input, Tabs, notification } from 'antd';
import { useDispatch } from 'react-redux';
import { CloudDownloadOutlined, DeleteOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

import { fetchEstimates } from '../../utilities/redux/slices/estimatesSlice';
import { fetchEstimate, loadTemplateEstimate } from '../../utilities/redux/slices/currentEstimate';
import axiosInstance from 'utilities/axios';
import { fetchTemplates } from 'utilities/redux/slices/templatesSlice';

const PastEstimatesModal = ({ open, onClose }) => {
  const dispatch = useDispatch();

  const estimates = useSelector((state) => state.estimates.data.data);
  const total = useSelector((state) => state.estimates.data.total);
  const templates = useSelector((state) => state.templates.data);

  const [search, setSearch] = useState('');

  useEffect(() => {
    dispatch(fetchEstimates({ search }));
  }, [search, dispatch]);

  useEffect(() => {
    dispatch(fetchTemplates());
  }, [dispatch]);

  const estimateColumns = [
    {
      title: 'Client Name',
      dataIndex: 'client_name',
      render: (text) => <span>{text || 'No Client Name'}</span>,
    },
    // {
    //   title: 'Client Email',
    //   dataIndex: 'client_email',
    // },
    {
      title: 'Created By',
      dataIndex: 'created_by',
      width: 120,
    },
    {
      title: 'Created Date',
      dataIndex: 'created_date',
      render: (text) => new Date(text).toLocaleDateString(),
    },
    // {
    //   title: 'Status',
    //   dataIndex: 'finalized',
    //   render: (record) => (
    //     <span>
    //       {record ? 'Finalized' : 'Draft'}
    //     </span>        
    //   ),
    //   width: 100,
    // },
    {
      title: 'Load Estimate',
      dataIndex: '',
      key: 'x',
      render: (record) => (
        <Button
          icon={<CloudDownloadOutlined />}
          onClick={() => {
            dispatch(fetchEstimate(record.estimate_id));
            onClose();
          }}
        >
          Load Estimate
        </Button>
      )
    }
  ];

  const templateColumns = [
    {
      title: 'Template Name',
      dataIndex: 'templateName',
      render: (text) => <span>{text || 'No Template Name'}</span>,
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      render: (text) => new Date(text).toLocaleDateString(),
    },
    {
      title: 'Load Template',
      dataIndex: '',
      key: 'x',
      render: (record) => (
        <Button
          icon={<CloudDownloadOutlined />}
          onClick={() => {
            dispatch(loadTemplateEstimate(record.estimateId));
            onClose();
          }}
        >
          Load Template
        </Button>
      )
    },
    {
      title: 'Delete Template',
      dataIndex: '',
      key: 'y',
      render: (record) => (
        <Button
          icon={<DeleteOutlined />}
          danger
          onClick={() => {
            axiosInstance
              .delete(`/templates/${record.estimateId}`)
              .then(() => {
                dispatch(fetchTemplates());
              })
              .catch((error) => {
                notification.error({
                  message: "Error",
                  description: "Failed to delete the estimate template.",
                });
              });
          }}
        >
          Delete Template
        </Button>
      )
    }
  ];

  const items = [
    {
      key: '1',
      label: `Past Estimates`,
      children: (
        <>
          <Input.Search
            placeholder="Search Estimates"
            allowClear
            size="large"
            onChange={e => setSearch(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          <Table
            scroll={{
              y: "40vh",
            }}
            bordered
            columns={estimateColumns}
            dataSource={estimates}
            rowKey={(record) => record.id}
            pagination={{
              total: total,
              showSizeChanger: true,
              onChange: (page, pageSize) => dispatch(fetchEstimates({ search, page, pageSize })),
            }}
          />
        </>
      )
    },
    {
      key: '2',
      label: `Estimate Templates`,
      children: (
        <>
          <Table
            scroll={{
              y: "40vh",
            }}
            bordered
            columns={templateColumns}
            dataSource={templates}
            rowKey={(record) => record.id}
          />
        </>
      )
    }
  ];

  return (
    <Modal
      title="Past Estimates and Templates"
      open={open}
      onCancel={onClose}
      footer={[
        <Button
          key="cancel"
          onClick={onClose}
        >
          Close
        </Button>
      ]}
      width={1000}
    >
      <Tabs
        defaultActiveKey="1"
        items={items}
      />
    </Modal>
  );
};

export default PastEstimatesModal;